function debounce(fn, delay = 500) {
  let timer = null;
  return (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export default {
  bind(el, { arg, value, modifiers }, vnode) {
    const delay =
      modifiers && Object.keys(modifiers).length !== 0
        ? Object.keys(modifiers)[0]
        : 500;
    const d_fn = debounce(value.bind(vnode), delay);
    el.addEventListener(arg, ev => {
      d_fn(ev);
    });
  }
}
